import { useTranslation } from 'react-i18next';
import { preferenceSlot } from '~/hooks/usePreferenceWriteQueue';
import { savedViewMessages } from '~/utils/savedViewMessages';
import {
  useSavedFilterViews,
  type SavedFilterViews,
} from '~/hooks/useSavedFilterViews';
import type { GetUserPreferencesQuery } from '~/graphql/graphql';
import { isRequestForQuoteFilterData } from '~/types';
import type { RequestForQuoteFilterRow } from '~/pages/my-requests-for-quote/lib/requestForQuoteFilters';
import {
  readRequestForQuoteRows,
  rowsToFilterData,
} from '~/pages/my-requests-for-quote/lib/requestForQuoteFilterStorage';

const REQUESTS_FOR_QUOTE_VIEW = 'REQUESTS_FOR_QUOTE' as const;

const REQUESTS_FOR_QUOTE_PERSPECTIVE = 'BUYING' as const;

type Preferences = GetUserPreferencesQuery['userPreferences'] | undefined;

export type RequestForQuoteSavedViews =
  SavedFilterViews<RequestForQuoteFilterRow>;

function activeIdOf(preferences: Preferences): string | null {
  return preferences?.buyerRequestForQuotesActiveFilterId ?? null;
}

function anonymousOf(preferences: Preferences): unknown {
  return preferences?.buyerRequestForQuotesAnonymousFilter;
}

export function useRequestForQuoteSavedViews(): RequestForQuoteSavedViews {
  const { t } = useTranslation('my-requests-for-quote');

  return useSavedFilterViews<RequestForQuoteFilterRow>({
    view: REQUESTS_FOR_QUOTE_VIEW,
    perspective: REQUESTS_FOR_QUOTE_PERSPECTIVE,
    slot: preferenceSlot('requestsForQuote', REQUESTS_FOR_QUOTE_PERSPECTIVE),
    isOwnFilterData: isRequestForQuoteFilterData,
    readRows: readRequestForQuoteRows,
    rowsToFilterData,
    activeIdOf,
    anonymousOf,
    anonymousPreferences: (rows) => ({
      buyerRequestForQuotesAnonymousFilter: rowsToFilterData(rows),
    }),
    messages: savedViewMessages(t, 'my_requests_for_quote.filter'),
  });
}
